
let styles = {
    container: {
      padding: '3%',
      display: 'flex',
      justifyContent: 'center',
    },

    table: {
        backgroundColor: '#dcdcdc',
        padding: '1%',
      },

    main_header: {
        padding: '1%',
        marginBottom: '3%',
        backgroundColor: '#32B6A7',
    },

    items: {
        padding: '1%',
    },

    item_body: {
        padding: '6px ',
      },

    input: {
        width: '50%',
    },
    
    item_header: {
        fontSize: '120%',
        fontWeight: 600,
        paddingLeft: '10%',
    },

    button_submit: {
        padding: '1%',
        justifyContent: 'center',
        display: 'flex',
        paddingTop: '6%',
    },
  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournamentTasks/style.js